import { i18n } from "../../../i18n/i18n";

import React, { Component } from 'react'
import { Pie } from 'react-chartjs-2'
import { Chart, ArcElement, Tooltip, Legend, Title } from 'chart.js'
import colorUtil from '../../../utils/color.util'
import locationService from '../../../services/location.service'
import itemService from '../../../services/item.service'
import itemApi, { ItemData } from '../../../apis/item.api'
import locationApi, { LocationData } from '../../../apis/location.api'
import chartApi from '../../../apis/chart.api'
import Row from '../../../components/Row/Row'
import Select from '../../../components/Select'
import SearchPicker, {
  SearchPickerOption
} from '../../../components/SearchPicker'
import Icon from '../../../components/Icon'

interface Props { }

interface State {
  locationId: string
  item: string
  itemId: string
  locationNames: string[]
  units: number[]
  locations: LocationData[]
  items: ItemData[]
}

export default class UnitsByLocation extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      locationId: '',
      item: '',
      itemId: '',
      locationNames: [],
      units: [],
      locations: [],
      items: []
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleSearchSelect = this.handleSearchSelect.bind(this)
    this.handleSearchBlur = this.handleSearchBlur.bind(this)
  }

  get data () {
    const { locationNames, units } = this.state
    const data = {
      labels: locationNames,
      datasets: [
        {
          data: units,
          backgroundColor: colorUtil.staticMaterialList(locationNames.length)
        }
      ]
    }
    return data
  }

  get locationSelectOptions () {
    return locationService.selectOptions(this.state.locations)
  }

  get itemSearchOptions () {
    return itemService.searchOptions(this.state.items)
  }

  get chart () {
    Chart.register(ArcElement, Tooltip, Legend, Title)
    return (
      <Pie
        data={this.data}
        options={{
          plugins: {
            title: {
              display: true,
              align: 'center',
              text: i18n('Units By Location')
            },
            legend: {
              labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                boxWidth: 10,
                boxHeight: 10
              }
            }
          },
          elements: {
            arc: {
              borderWidth: 1
            }
          }
        }}
        className="mb-3" />
    )
  }

  get filterFields () {
    return (
      <Row column={2}>
        <Select
          name="location"
          value={this.state.locationId}
          options={this.locationSelectOptions}
          label={i18n("Location")}
          onChange={this.handleInputChange} />
        <SearchPicker
          name="item"
          value={this.state.item}
          options={this.itemSearchOptions}
          label={i18n("Item")}
          onSearch={this.handleSearch}
          onChange={this.handleInputChange}
          onSelect={this.handleSearchSelect}
          onBlur={this.handleSearchBlur} />
      </Row>
    )
  }

  handleInputChange (name: string, value: string) {
    if (name === 'location') {
      this.setState({ locationId: value }, () => {
        this.readUnitsByLocation()
      })
    } else if (name === 'item') this.setState({ itemId: '', item: value })
  }

  handleSearch (name: string, term: string) {
    if (name === 'item') {
      itemApi.search(term, items => {
        if (!items) return
        this.setState({ items })
      })
    }
  }

  handleSearchSelect (name: string, option: SearchPickerOption) {
    if (name === 'item') {
      const { value } = option
      const itemId = option.id
      this.setState({ items: [], item: value, itemId: String(itemId) }, () => {
        this.readUnitsByLocation()
      })
    }
  }

  handleSearchBlur (name: string) {
    if (name === 'item') {
      this.setState({ items: [] })
    }
  }

  handleClear = () => {
    this.setState({
      locationId: '',
      item: '',
      itemId: ''
    }, () => {
      this.readUnitsByLocation()
    })
  }

  readUnitsByLocation () {
    const { locationId, itemId } = this.state
    chartApi.unitsByLocation(locationId, itemId, unitsByLocation => {
      if (!unitsByLocation) return
      const { locations, units } = unitsByLocation
      this.setState({ locationNames: locations, units })
    })
  }

  listLocations () {
    locationApi.list(locations => {
      if (!locations) return
      this.setState({ locations })
    })
  }

  componentDidMount () {
    this.readUnitsByLocation()
    this.listLocations()
  }

  render () {
    return (
      <div>
        <button
          onClick={this.handleClear}
        >
          <Icon name='refresh' size='medium' color="dark" />
        </button>
        {this.chart}
        {this.filterFields}
      </div>
    )
  }
}
